import { ENROLLMENT_TYPES } from '@backrs_ui/common-ui/src/models/profile';

export const determineGradeLevel = (
  academicExpectedGraduationYear: number | undefined,
  academicEnrollmentType: string,
): string | undefined => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0 = Jan, 11 = Dec

  // If it's July or later, bump the academic year
  const effectiveAcademicYear = currentMonth >= 6 ? currentYear + 1 : currentYear;
  const yearsUntilGraduation = academicExpectedGraduationYear
    ? academicExpectedGraduationYear - effectiveAcademicYear
    : undefined;

  if (!academicEnrollmentType && !!academicExpectedGraduationYear) {
    return academicExpectedGraduationYear.toString();
  }

  const graduationYear = academicExpectedGraduationYear
    ? ` (${academicExpectedGraduationYear})`
    : '';

  if (
    academicEnrollmentType === ENROLLMENT_TYPES.HIGH_SCHOOL ||
    academicEnrollmentType === ENROLLMENT_TYPES.COLLEGE_UNIVERSITY
  ) {
    switch (yearsUntilGraduation) {
      case undefined:
        return academicEnrollmentType;
      // if it's past May 31 of the graduation year, yearsUntilGraduation is -1
      case -1:
      case 0:
        return `Senior${graduationYear}`;
      case 1:
        return `Junior${graduationYear}`;
      case 2:
        return `Sophomore${graduationYear}`;
      default:
        return `Freshman${graduationYear}`;
    }
  }

  if (academicEnrollmentType === ENROLLMENT_TYPES.NOT_CURRENTLY_A_STUDENT) {
    return 'Not currently a student';
  }

  return `${academicEnrollmentType}${graduationYear}`;
};
